import Elements from "./elements"

class CreditCard {
  constructor(element, form) {
    this.stripe = Stripe(window.stripeKey, { locale: 'pt' })
    this.elements = this.stripe.elements()
    this.card = this.elements.create('card', { style: Elements.styles() })
    this.card.mount(element)
    this.card.addEventListener('change', this.onChange.bind(this))
    this.card.addEventListener('focus', this.onFocus.bind(this))
    this.form = form
    this.isValid = false
    this.isCardValid = false
    this.bindExistingCards()
  }

  bindExistingCards() {
    const existingCards = this.form.querySelectorAll('.existing-card')
    existingCards.forEach((card) => {
      card.addEventListener('change', () => {
        this.isValid = true
        this.form.dispatchEvent(new CustomEvent('payment:valid'))
      })
    })
  }

  onChange(card) {
    if (card.complete) {
      this.form.dispatchEvent(new CustomEvent('payment:valid'))
      this.isValid = true
      this.isCardValid = true
    } else if (card.error) {
      this._triggerError(card.error.message)
    } else {
      this._triggerError()
    }
  }

  onFocus() {
    const checkedCard = this.form.querySelector('.existing-card:checked')
    if (checkedCard) checkedCard.checked = false

    if (!this.isCardValid) this.form.dispatchEvent(new CustomEvent('payment:invalid'))
  }

  process() {
    const existingCard = this.form.querySelector('.existing-card:checked')
    if (existingCard) {
      this._assignSubscription(existingCard.value)
    } else {
      this.stripe
        .createPaymentMethod('card', this.card)
        .then((result) => {
          if (result.error) {
            this._triggerError(result.error.message)
          } else {
            this._assignSubscription(result.paymentMethod.id)
          }
        })
    }
  }

  _assignSubscription(nonce) {
    return fetch(this.form.action, {
      method: 'put',
      headers: {
        'Content-Type': 'application/json',
        'X-CSRF-Token': this.token
      },
      body: JSON.stringify({ nonce: nonce })
    }).then(response => {
      return response.json()
    }).then(data => {
      if (data.success) {
        this._handleSubscription(data.subscription)
      } else {
        this.form.dispatchEvent(new CustomEvent('payment:error', { bubbles: true, detail: data.message }))
      }
    })
  }

  _handleSubscription(subscription) {
    const { latest_invoice } = subscription
    const { payment_intent } = latest_invoice

    if (payment_intent) {
      const { client_secret, status } = payment_intent

      if (status === 'requires_action' || status === 'requires_payment_method') {
        this.stripe.confirmCardPayment(client_secret).then((result) => {
          if (result.error) {
            this._triggerError(result.error.message)
          } else {
            this._complete()
          }
        })
      } else {
        this._complete()
      }
    } else {
      this._complete()
    }
  }

  _complete() {
    return fetch(`${this.form.action}/complete`, {
      method: 'put',
      headers: {
        'Content-Type': 'application/json',
        'X-CSRF-Token': this.token
      }
    }).then(response => {
      return response.json()
    }).then(data => {
      window.location = data.location
    })
  }

  _triggerError(message = null) {
    this.form.dispatchEvent(new CustomEvent('payment:invalid', { detail: message }))
    this.isValid = false
    this.isCardValid = false
  }

  get token() {
    return document.querySelector('meta[name=csrf-token]').content
  }

  get valid() {
    return this.isValid
  }

  get automatic() {
    return true
  }
}

export default CreditCard